module.exports = __webpack_public_path__ + "img/larson.beaf7d6e.jpg";